import { ApplicationError } from '@office-start/application-error';
import { parseJsonElementWithId } from '@office-start/dom-parser-utility';
export function parseConfig(configElementId) {
    try {
        return parseJsonElementWithId(configElementId);
    }
    catch (ex) {
        throw new ApplicationError("Failure to parse ".concat(configElementId, " from response"), ex);
    }
}
//# sourceMappingURL=parseConfig.js.map